// Build calendar-export URLs/files from a session for "Add to my calendar".
const toCal = (iso) => new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

export function googleCalUrl({ title, start, end, details, location }) {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title || "Frenchies",
    dates: `${toCal(start)}/${toCal(end)}`,
    details: details || "",
    location: location || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function downloadIcs({ title, start, end, details, location }) {
  const esc = (s) => (s || "").replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Frenchies//Schedule//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${toCal(start)}-${Math.random().toString(36).slice(2)}@frenchies`,
    `DTSTAMP:${toCal(new Date().toISOString())}`,
    `DTSTART:${toCal(start)}`,
    `DTEND:${toCal(end)}`,
    `SUMMARY:${esc(title)}`,
    `DESCRIPTION:${esc(details)}`,
    `LOCATION:${esc(location)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(title || "frenchies").replace(/\s+/g, "_")}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
